export default "__VITE_ASSET__Cv$QSAvP__"